require('./index.scss')

import { useEffect, useState } from 'react'

import ReduxProvider from '@/components/ReduxProvider'
import { translate } from '@/utils/translations'

import SkeletonThemeWrapper from '../SkeletonThemeWrapper'
import Modal from './Modal'

const CarbonNeutralityDialog = () => {
  const key = 'pages.store_home.carbon_neutrality'

  const [isShowing, setIsShowing] = useState(false)
  const [isShowingComponent, setIsShowingComponent] = useState(false)

  useEffect(() => {
    setIsShowingComponent(true)
  })

  return (
    <Choose>
      <When condition={isShowingComponent}>
        <div
          className='d-flex flex-column align-items-center mt-3'
          id='carbon-neutrality'
        >

          <div id='carbon-neutrality-icon'>
            <img
              alt={translate(`${key}.planet_smart`)}
              height={48}
              src={require('./images/planet-smart-icon.svg')}
              width={144}
            />
          </div>
          <Modal
            isShowing={isShowing}
            onChangeShow={setIsShowing}
          />
          <button
            className='u-align--center vst-btn--transparent
              styled-as-link u-weight--medium mt-2'
            onClick={() => setIsShowing(true)}
          >
            {translate('pages.store_home.carbon_neutrality.purchase')}
          </button>
        </div>
      </When>
      <Otherwise>
        <SkeletonThemeWrapper count={1} />
      </Otherwise>
    </Choose>
  )
}

/*eslint-disable react/no-multi-comp*/
const Component = () => (
  <ReduxProvider>
    <CarbonNeutralityDialog />
  </ReduxProvider>
)
export default Component
